// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconImageImageBrightnessFull_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M11 0H13V3H11V0Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19Z" class="svg-bg"/>
  <path d="M13 21V24H11V21H13ZM24 13H21V11H24V13ZM3 11V13H0V11H3ZM21.1914 19.7783 19.7772 21.1925 17.6559 19.0712 19.0701 17.657 21.1914 19.7783ZM6.34375 4.92871 4.92954 6.34292 2.80822 4.2216 4.22243 2.80739 6.34375 4.92871ZM4.22266 21.1914 2.80844 19.7772 4.92976 17.6559 6.34398 19.0701 4.22266 21.1914ZM19.0703 6.34375 17.6561 4.92954 19.7774 2.80822 21.1916 4.22243 19.0703 6.34375Z" class="svg-bg"/>
</svg>
`;
/**
 * IconImageImageBrightnessFull is a generated icon component.
 */
let IconImageImageBrightnessFull = IconImageImageBrightnessFull_1 = class IconImageImageBrightnessFull extends IconBaseElement {
    render() {
        return html `${IconImageImageBrightnessFull_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconImageImageBrightnessFull.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconImageImageBrightnessFull = IconImageImageBrightnessFull_1 = __decorate([
    customElement('zui-icon-image-image-brightness-full')
], IconImageImageBrightnessFull);
export { IconImageImageBrightnessFull };
